import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-disabled"]
const _hoisted_2 = { class: "explainer-row-action" }
const _hoisted_3 = { class: "explainer-row-arrow" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Row',
  props: {
    icon: { type: String, required: true },
    arrow: { type: String, required: false },
    disabled: { type: Boolean, required: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "explainer-row",
    "data-disabled": __props.disabled || undefined
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.icon), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.arrow ?? (__props.disabled ? '↛' : '→')), 1 /* TEXT */),
    _renderSlot(_ctx.$slots, "default")
  ], 8 /* PROPS */, _hoisted_1))
}
}

})